import { fetchApi } from '@/services/api-client';

export type NotificationUrgency = 'urgent' | 'action' | 'info' | 'silent';

export type NotificationItem = {
  id: string;
  category: string;
  type: string;
  params: Record<string, string | number>;
  href: string;
  createdAt: string;
  readAt: string | null;
  urgency: NotificationUrgency;
};

export type PendingToasts = { items: NotificationItem[]; total: number };

export type NotificationFeedPage = { items: NotificationItem[]; nextCursor: string | null };

export const notificationsApi = {
  feed: (cursor?: string) =>
    fetchApi<NotificationFeedPage>(`/notifications${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''}`),
  unreadCount: () => fetchApi<{ count: number }>('/notifications/unread-count'),
  markRead: (body: { ids: string[] } | { all: true }) =>
    fetchApi<void>('/notifications/mark-read', { method: 'POST', body: JSON.stringify(body) }),
  markUnread: (id: string) =>
    fetchApi<void>('/notifications/mark-unread', { method: 'POST', body: JSON.stringify({ id }) }),
  seenPath: (path: string) =>
    fetchApi<void>('/notifications/seen-path', { method: 'POST', body: JSON.stringify({ path }) }),
  pendingToasts: () => fetchApi<PendingToasts>('/notifications/pending-toasts'),
  clearAll: () => fetchApi<void>('/notifications', { method: 'DELETE' }),
};

export const notificationsKeys = {
  all: ['notifications'] as const,
  feed: ['notifications', 'feed'] as const,
  unreadCount: ['notifications', 'unread-count'] as const,
  pendingToasts: ['notifications', 'pending-toasts'] as const,
};

/** Re-declared here: the API's event-name constant lives in a package this app can't import. */
export const NOTIFICATIONS_CHANGED_EVENT = 'notifications.changed';
